import React, { useState, useEffect } from "react";
import { Layout, Menu, Breadcrumb, Button, Drawer, Grid } from "antd";
import {
  MenuOutlined,
  HomeOutlined,
  UserOutlined,
  TeamOutlined,
  TrophyOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  ScheduleOutlined,
  IdcardOutlined,
  PictureOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { Outlet, useNavigate } from "react-router-dom";

const { Header, Content, Footer, Sider } = Layout;
const { useBreakpoint } = Grid;

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();
  const navigate = useNavigate();

  const isMobile = !screens.md; // md = 768px breakpoint

  const menuItems = [
    { key: "0", icon: <HomeOutlined />, label: "Home", path: "/dashboard/" },
    { key: "1", icon: <UserOutlined />, label: "Users", path: "/dashboard/users" },
    { key: "2", icon: <TeamOutlined />, label: "Teams", path: "/dashboard/teams" },
    { key: "3", icon: <TrophyOutlined />, label: "Matches", path: "/dashboard/matches" },
    { key: "4", icon: <IdcardOutlined />, label: "Players", path: "/dashboard/players" },
    { key: "5", icon: <BarChartOutlined />, label: "Player Stats", path: "/dashboard/player-stats" },
    { key: "6", icon: <PictureOutlined />, label: "Sliders", path: "/dashboard/sliders" },
    { key: "8", icon: <AppstoreOutlined />, label: "Tournaments", path: "/dashboard/tournaments" },
    { key: "9", icon: <ScheduleOutlined />, label: "Contests", path: "/dashboard/contests" },
    { key: "10", icon: <PlayCircleOutlined  />, label: "Start Tournament", path: "/dashboard/start" },
    { key: "11", icon: <PlayCircleOutlined  />, label: "Ultimate Tournament", path: "/dashboard/ultimate" },
  ];

  const handleMenuClick = (e) => {
    const item = menuItems.find((i) => i.key === e.key);
    if (item) {
      navigate(item.path);
      if (isMobile) setDrawerVisible(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [isMobile]);

  const SidebarMenu = (
    <Menu
      theme="dark"
      mode="inline"
      items={menuItems}
      onClick={handleMenuClick}
      style={{ fontSize: "16px" }}
    />
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!isMobile && (
        <Sider
          width={220}
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
        >
          <div
            style={{
              height: 40,
              margin: 16,
              color: "#fff",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Admin Panel
          </div>
          {SidebarMenu}
        </Sider>
      )}

      {/* MOBILE DRAWER NAV */}
      <Drawer
        title="Admin Menu"
        placement="left"
        closable
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        bodyStyle={{ padding: 0 }}
      >
        {SidebarMenu}
      </Drawer>

      <Layout>
        <Header
          style={{
            background: "#fff",
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Mobile Menu Button */}
          {isMobile && (
            <MenuOutlined
              style={{ fontSize: "20px", marginRight: 16 }}
              onClick={() => setDrawerVisible(true)}
            />
          )}

          {/* Push logout button to the right */}
          <div style={{ marginLeft: "auto" }}>
            <Button type="primary" danger onClick={handleLogout}>
              Logout
            </Button>
          </div>
        </Header>

        <Content style={{ margin: "16px" }}>
          {!isMobile && (
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Admin</Breadcrumb.Item>
              <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
            </Breadcrumb>
          )}

          <div
            style={{
              padding: 16,
              minHeight: "70vh",
              background: "#fff",
              borderRadius: 8,
            }}
          >
            <Outlet />
          </div>
        </Content>

        <Footer style={{ textAlign: "center", fontSize: "14px" }}>
          X Eleven Sports ©2025
        </Footer>
      </Layout>
    </Layout>
  );
};

export default Dashboard;

